export default {
	NOTICE: 'notice',
	QNA: 'qna',
};
